<template>
  <div class="form-step">
    <v-row>
      <v-col cols="5" class="mb-2">
        <v-label class="label mb-3">PSI Type:</v-label>
        <v-autocomplete
          label="Enter PSI Type"
          :items="psiTypes"
          item-title="text"
          item-value="value"
          variant="solo"
          v-model="props.modelValue.name"
          hint="Select one of the available PSIs"
          persistent-hint
          class="mb-6"
          @update:modelValue="onChange"
        />
        <span v-if="selectedFunctionalUnit" style="font-size: 14px"
          ><strong>Functional Unit: </strong>{{ selectedFunctionalUnit }}</span
        >
      </v-col>
      <hr />
    </v-row>

    <v-row>

      <!-- CALL IMPACT LABEL -->
      <v-col cols="5">
        <label class="label"
        ><b class="mr-2">Call Impact:</b>
          <v-tooltip text="The call impact number given in the proposal.">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                size="x-small"
                icon
                variant="outlined"
                color="#0d47a1"
              >
                <v-icon color="black" icon="fa fa-sm fa-info" />
              </v-btn>
            </template>
          </v-tooltip>
        </label>
        <v-select
          label="Call Impact number"
          v-model="props.modelValue.call_impact"
          item-title="text"
          item-value="value"
          :items="optionsForCi"
          variant="solo"
          hint="Select one of the available call impacts"
          persistent-hint
        ></v-select>
      </v-col>

      <!-- VALUE LABEL -->
      <v-col cols="5">
        <label class="label mr-5">
          <b class="mr-2">Value:</b>
          <v-tooltip text="Please enter a real value.">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                size="x-small"
                icon
                variant="outlined"
                color="#0d47a1"
              >
                <v-icon color="black" icon="fas fa-info" />
              </v-btn>
            </template> </v-tooltip
        ></label>
        <v-text-field
          v-model="props.modelValue.value"
          clearable
          label="Value that corresponds to the Call Impact"
          hint="Enter a real value"
          persistent-hint
          variant="solo"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { computed } from "vue";

const emit = defineEmits(["name-changed"]);

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  psiTypes: {
    value: Array,
    required: true,
  },
});

const validation = computed(() => {
  return props.modelValue.name !== null;
});

const selectedFunctionalUnit = computed(() => {
  const obj = props.psiTypes.find(
    (type) => type.value === props.modelValue.name
  );
  if (obj !== undefined) return obj.functionalUnit;
  return null;
});

const optionsForCi = [
  { value: null, text: "No Call Impact" },
  { value: "", text: "- Call Impact Numbers -", disabled: true },
  { value: "1", text: "Call Impact #1" },
  { value: "2", text: "Call Impact #2" },
  { value: "3", text: "Call Impact #3" },
  { value: "4", text: "Call Impact #4" },
  { value: "5", text: "Call Impact #5" },
  { value: "6", text: "Call Impact #6" },
  { value: "7", text: "Call Impact #7" },
];

function onChange(selectedName) {
  const selectedType = props.psiTypes.find(
    (type) => type.value === selectedName
  );

  if (selectedType) {
    props.modelValue.psi_type_id = selectedType.psi_type_id;
  }

  emit("name-changed", selectedType);
}
</script>

<style scoped>
.label {
  font-size: medium;
}
strong {
  font-size: medium;
}
</style>
